// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-fraud-category-js": () => import("./../src/components/fraud-category.js" /* webpackChunkName: "component---src-components-fraud-category-js" */),
  "component---src-components-fraud-technique-js": () => import("./../src/components/fraud-technique.js" /* webpackChunkName: "component---src-components-fraud-technique-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-style-guide-js": () => import("./../src/pages/style-guide.js" /* webpackChunkName: "component---src-pages-style-guide-js" */)
}

